var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFuncaoDivisao01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "division",
    transform: "translate(114 913.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2184",
    transform: "translate(-1 20.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1203",
    d: "M-79-917.6h-31.9c-0.8,0-1.5,0.6-1.5,1.4c0,0.8,0.6,1.5,1.4,1.5c0,0,0,0,0.1,0H-79 c0.8,0,1.4-0.7,1.4-1.5C-77.6-917-78.2-917.6-79-917.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1204",
    d: "M-95-920.5c3.2,0,5.8-2.6,5.8-5.8c0-3.2-2.6-5.8-5.8-5.8c-3.2,0-5.8,2.6-5.8,5.8c0,0,0,0,0,0 C-100.8-923.1-98.2-920.5-95-920.5z M-95-929.2c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9 S-96.6-929.2-95-929.2C-95-929.2-95-929.2-95-929.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1205",
    d: "M-95-911.8c-3.2,0-5.8,2.6-5.8,5.8c0,3.2,2.6,5.8,5.8,5.8c3.2,0,5.8-2.6,5.8-5.8S-91.8-911.8-95-911.8 L-95-911.8z M-95-903.1c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9c1.6,0,2.9,1.3,2.9,2.9l0,0 C-92.1-904.4-93.4-903.1-95-903.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoDivisao01);
export default __webpack_public_path__ + "static/media/ico-funcao-divisao-01.a48961f190fa5c6f4e7643e47c724974.svg";
export { ForwardRef as ReactComponent };